import React from 'react';
import { Image } from "react-native"
import { Button } from "../Components/Themed";

type ImageRendererProps = {
    image: { url:string, height?:number, width?:number },
    style?:any,
    width: number,
    max_height?:number,
    allow_aspect_change?:boolean,
    onSelectImage?:(image:{ url:string, height?:number, width?:number, [key:string]:any }) => void
}
const ImageRenderer = ({ image, width, onSelectImage, max_height, style, allow_aspect_change }:ImageRendererProps) => {
    const getImageRatio = () => {
        let ratio = 1
        if(image.width && image.height){
            ratio = image.width / image.height
        }
        return ratio
    }
    const ratio = getImageRatio();

    let image_width = width
    let image_height = width * ratio

    if(max_height && image_height > max_height){
        image_height = max_height
        if(!allow_aspect_change){ image_width = image_height / ratio }
    }

    return (
        <Button disabled={!onSelectImage} transparent style={{ padding:0 }} onPress={() => onSelectImage ? onSelectImage(image) : console.log('')}>
            <Image
                source={{ uri: image.url }}
                style={{ height: image_height, width: image_width, ...style }}
                resizeMode="cover"
            />
        </Button>
    )
}

export default ImageRenderer